module.exports = __webpack_public_path__ + "img/vegan.fe500d9c.svg";